export default "__VITE_ASSET__D1t4OqPw__"